import Swiper from 'swiper/bundle';

jQuery(document).ready(() => {
    if (jQuery('.events-slider__swiper').length) {
        const swiper = new Swiper(".events-slider__swiper", {
            slidesPerView: 1.15,
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    spaceBetween: 40,
                    slidesPerView: 1.5,
                },
            },
        });
    }
});